import classNames from 'classnames';
import Link from 'next/link';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import Heading from '../../../../atoms/Heading';
import BaseTemplate from '../../../../organisms/merchants/BaseTemplate';
import BookingPageCard from '../../../../molecules/merchant/common/cards/BookingPageCard';
import { MerchantDetail } from '../../../../interfaces/merchants';
import { CouponCalendarOrganism } from '../../../../organisms/merchants/coupons/CouponCalendar';
import css from './style.module.scss';
import { VoucherAssignedBookingPage } from '../../../../infrastructure/api/coupon';
import { buildSiteUrl } from 'src/utils/request-url';

interface PageProps {
  // ゆくゆくはAPIの戻り値であるMerchantDetailをそのまま渡したくない
  merchant: MerchantDetail;
  coupon: {
    name: string;
    publicId: string;
    assignedBookingPages: VoucherAssignedBookingPage[];
  };
  isCoubicApp: boolean;
}

const CouponDetailTemplate: FC<PageProps> = ({
  merchant,
  coupon,
  isCoubicApp,
}) => {
  const intl = useIntl();
  return (
    <BaseTemplate merchantDetail={merchant} isCoubicApp={isCoubicApp}>
      <div className={css.container}>
        <div className={css.mb_16px}>
          <Heading className={css['heading']}>
            <Link
              href={buildSiteUrl(`/coupons/${coupon.publicId}`, 'next')}
              prefetch={false}
              className={css.header_link}
            >
              {coupon.name}
            </Link>
          </Heading>
        </div>
        <div className={css.mb_16px}>
          <p className={classNames(css.please_select_booking_page)}>
            {intl.formatMessage({
              id: 'couponDetailTemplate.pleaseSelectBookingPage',
            })}
          </p>
          <p className={classNames(css.first_time_only_coupon)}>
            <span className={css.coupon_condition}>
              {intl.formatMessage({
                id: 'couponDetailTemplate.couponCondition',
              })}
            </span>
            {intl.formatMessage(
              {
                id: 'couponDetailTemplate.firstTimeOnlyCouponWarning',
              },
              { merchantName: merchant.display_name },
            )}
          </p>
        </div>
      </div>
      <div className={css.mb_32px}>
        <CouponCalendarOrganism
          merchantPublicId={merchant.public_id}
          merchantTimeZone={merchant.time_zone}
          couponPublicId={coupon.publicId}
        />
      </div>
      <div className={classNames(css.flex_col_gap_16px, css.mb_32px)}>
        {coupon.assignedBookingPages.map((bookingPage) => (
          <div key={bookingPage.public_id} className={css.mobile_mx_16px}>
            <BookingPageCard
              title={bookingPage.name}
              description={bookingPage.description_text ?? ''}
              thumbnailUrl={bookingPage.primary_image?.thumb?.url ?? ''}
              href={buildSiteUrl(`/${bookingPage.public_id}#pageContent`)}
              tags={bookingPage.tag_names}
              lowestPrice={bookingPage.lowest_price}
            />
          </div>
        ))}
      </div>
    </BaseTemplate>
  );
};

export default CouponDetailTemplate;
